export var defaultProps = {
    className: '',
    style: undefined,
    accordion: false,
    hasBorder: true,
    iconPosition: 'right',
    defaultActiveKey: [],
    activeKey: [],
    onChange: function (key, activeKey) { },
};
export var defaultPanelProps = {
    disabled: false,
    header: '',
    icon: true,
    isActive: false,
    panelKey: '',
    hasBorder: false,
    accordion: false,
    onChange: function (isOpen, activeKey) { },
};
